import { Link } from "react-router-dom";
import { Instagram, Mail } from "lucide-react";
import { nav, site } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-dark text-paper" data-testid="site-footer">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 pt-24 pb-10">
        <p className="font-serif italic text-4xl sm:text-5xl lg:text-7xl leading-tight max-w-4xl">
          Pensiero, parole, libertà.
        </p>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-12 border-t border-paper/15 pt-12">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-paper/50">
              Navigazione
            </p>
            <ul className="mt-5 space-y-3">
              {nav.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-paper/80 hover:text-paper transition-colors link-underline"
                    data-testid={`footer-link-${item.to === "/" ? "home" : item.to.slice(1)}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-paper/50">
              Seguimi
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <a
                  href={site.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 text-sm text-paper/80 hover:text-paper transition-colors"
                  data-testid="footer-instagram-link"
                >
                  <Instagram size={16} strokeWidth={1.5} />
                  Instagram — luisa_miceli_
                </a>
              </li>
              {site.instagramASpace && (
                <li>
                  <a
                    href={site.instagramASpace}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-paper/80 hover:text-paper transition-colors"
                    data-testid="footer-instagram-aspace-link"
                  >
                    <Instagram size={16} strokeWidth={1.5} />
                    Instagram — A-Space Art
                  </a>
                </li>
              )}
              {site.instagramASpace && (
                <li>
                  <a
                    href="https://aspaceart2.wixsite.com/ilmiosito"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 text-sm text-paper/80 hover:text-paper transition-colors"
                    data-testid="footer-aspace-site-link"
                  >
                    A-Space Art — sito del progetto
                  </a>
                </li>
              )}
              {site.email && (
                <li>
                  <a
                    href={`mailto:${site.email}`}
                    className="inline-flex items-center gap-2 text-sm text-paper/80 hover:text-paper transition-colors"
                    data-testid="footer-email-link"
                  >
                    <Mail size={16} strokeWidth={1.5} />
                    {site.email}
                  </a>
                </li>
              )}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-paper/50">
              Note legali
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <Link
                  to="/privacy"
                  className="text-sm text-paper/80 hover:text-paper transition-colors link-underline"
                  data-testid="footer-link-privacy"
                >
                  Privacy policy
                </Link>
              </li>
              <li>
                <Link
                  to="/cookie-policy"
                  className="text-sm text-paper/80 hover:text-paper transition-colors link-underline"
                  data-testid="footer-link-cookie"
                >
                  Cookie policy
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 border-t border-paper/15 pt-8">
          <p className="font-mono text-[11px] text-paper/50">
            © {year} Luisa Miceli — Tutti i diritti riservati
          </p>
          <p className="font-mono text-[11px] text-terracotta uppercase tracking-[0.25em]">
            Filosofa · Scrittrice · Poetessa
          </p>
        </div>
      </div>
    </footer>
  );
}
